import axios from "axios";
const baseURL1 = process.env.REACT_APP_BASE_URL_APP;
const baseURL2 = process.env.REACT_APP_BASE_URL_WEB;

async function fetch_users_data(clientName, page, rowsPerPage, token) {
  try {
    const response = await axios.get(
      `${baseURL1}/api/user/getUsersbyclient?clientName=${clientName}&page=${page + 1}&pageSize=${rowsPerPage}`,
      {headers: {
        Authorization: `Bearer ${token}`}});
    if (response.status === 200) {
      return { success: true, data: response?.data?.response?.[0], code: 200 };
    } else {
      return { success: false, error: "unexpected status code "+response.status};
    }
  } catch (error) {
    console.error("Error fetching users data:", error);
    return {success: false, error:  error.response?.data?.error || error.message || "could not fetch users data"};
  }
}

async function getUserLogs(userid, token) {
  try {
    const response = await axios.get(
      `${baseURL1}/api/user/logs?userid=${userid}`,{headers: {
          Authorization: `Bearer ${token}`}}
    );

    if (response.status === 200) {
      return { success: true, data: response.data?.list};
    } else{
      return { success: false, error: "unexpected status code "+response.status};
    }
  } catch (error) {
    console.error("Error fetching user logs:", error);
    return {success: false,  error:  error.response?.data?.error || error.message || "could not fetch user logs"};
  }
}

async function fetchGraphData(state, district, sub_district, crop, infest) {
  try {
    let url = sub_district ? `${baseURL2}/api/location/infest/subdist` : `${baseURL2}/api/location/infest`;
    const response = await axios.post(url,  {
      state: state,
      district: district,
      sub_district: sub_district,
      crop: crop,
      infest: infest,
    });

    if (response.status ===200) {
      return { success: true, data: response.data};
    } else {
      return {success: false, error: "Unexpected status code "+response.status};
    }
  } catch (error) {
    console.error("Error fetching infest subdist data:", error);
    return {success: false, error: error.response?.data?.error || error.message || "could not fetch infest subdistrict data"};
  }
}
async function deactivateUser(userid, token) {
  try {
    const response = await axios.post(
      `${baseURL1}/api/user/deactivateUser?userID=${userid}`,{},{headers: {
          Authorization: `Bearer ${token}`}}
    );

    if (response.status === 200) {
      return { success: true};
    } else {
      console.error("Unexpected status code:", response.status);
      return {success: false, error: "Unexpected status code "+response.status};
    }
  } catch (error) {
    console.error("Error deactivating user:", error);
    return {success: false,  error:  error.response?.data?.error || error.message || "could not de activate user"};
  }
}

async function activateUser(userid, token) {
  try {
    const response = await axios.post(
      `${baseURL1}/api/user/activateUser?userID=${userid}`,{},{headers: {
      Authorization: `Bearer ${token}`}}
  );

    if (response.status === 200) {
      return { status: true };
    } else {
      console.error("Unexpected status code:", response.status);
      return {success: false, error: "Unexpected status code "+response.status};
    }
  } catch (error) {
    console.error("Error activating user:", error);
    return {success: false,  error:  error.response?.data?.error || error.message || "could not activate user"};
  }
}

async function downloadCSV(state, infest, crop, district, sub_district) {
  try {
    const response = await axios.post(`${baseURL2}/api/location/csv`, {
      state: state,
      infest: infest,
      crop: crop,
      district: district,
      sub_district: sub_district,
    });
    if (response.status===200) {
      const data = response.data?.geojson||[];
      createAndDownloadCSV(data);
    } else {
      console.error("API call failed");
      createAndDownloadCSV([]);
    }
  } catch (error) {
    console.error("Error fetching csv data:", error);
    createAndDownloadCSV([]);
  }
}

function createAndDownloadCSV(data) {
  const keys = data.length
    ? Object.keys(data[0])
    : [
      "unq",
      "staten",
      "districtn",
      "blockn",
      "village",
      "village_latitude",
      "village_longitude",
      "crop_name",
      "crop_avg_sowing_date",
      "sowing_period",
      "is_crop_active",
      "pest",
      "current_week_forecast",
      "next_week_forecast",
      "previous_week",
    ];

  const csvContent = data.length
    ? [
      keys.join(","),
      ...data.map((item) =>
        keys.map((key) => (item[key] === null ? "" : item[key])).join(",")
      ),
    ].join("\n")
    : keys.join(",") + "\n";

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);
  link.setAttribute("href", url);
  link.setAttribute("download", "data.csv");
  link.style.visibility = "hidden";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

async function loginUser(payload) {

    try{
    const response = await axios.post(`${baseURL1}/api/user/login`,{...payload} ,{
      headers: {
        'Content-Type': 'application/json',
      }
    });
    if(response.status === 200) {
      return { success: true, data: response.data };
    }else {
      return {success: false, error: "Unexpected status code "+response.status};
    }
  }catch(error){
    console.error("Error logging in user:", error);
    return {success: false,  error:  error.response?.data?.error || error.message || "could not login user"};
  }
}

export {
  fetch_users_data,
  deactivateUser,
  activateUser,
  fetchGraphData,
  getUserLogs,
  downloadCSV,
  loginUser,
};
